import { createAsyncAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import {
  PostConsumptionBodyType,
  PostConsumptionResponseType,
} from '../../lib/common/type';

export const POST_CONSUMPTION = 'common/POST_CONSUMPTION' as const;
export const POST_CONSUMPTION_SUCCESS = 'common/POST_CONSUMPTION_SUCCESS' as const;
export const POST_CONSUMPTION_ERROR = 'common/POST_CONSUMPTION_ERROR' as const;

export const postConsumptionAsync = createAsyncAction(
  POST_CONSUMPTION,
  POST_CONSUMPTION_SUCCESS,
  POST_CONSUMPTION_ERROR
)<PostConsumptionBodyType, PostConsumptionResponseType, AxiosError>();
